module.exports = __webpack_public_path__ + "static/media/free-root-beer-2024-dt-en.c81c176e.jpg";